<template>
  <div class="my-1">
    <button @click="isOpen = !isOpen" class="w-full p-2 text-left">
      {{ title }}
    </button>
    <div :class="isOpen ? 'block' : 'hidden'">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  props: ["title"],
};
</script>